"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const StyledContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n  @media (min-width: ", ") {\n    width: 750px;\n  }\n  @media (min-width: ", ") {\n    width: 970px;\n  }\n  @media (min-width: ", ") {\n    width: 1170px;\n  }\n  ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoint.sm;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoint.md;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.breakpoint.lg;
}, _ref4 => {
  var _theme$components, _theme$components$con;

  let {
    theme
  } = _ref4;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$con = _theme$components.container) === null || _theme$components$con === void 0 ? void 0 : _theme$components$con.container;
});

exports.StyledContainer = StyledContainer;